/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EntryDAO from 'dao/EntryDAO';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderSelectorModal from 'file-browser/FolderSelectorModal';
import CloneModal from 'folder-items/CloneModal';
import {EntryWithFulfillments} from 'notebook/ELNConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';
import APIUtil from 'util/APIUtil';

interface Props {
  disabled?: boolean;
  files: Array<any>;
  initialSelectedFolderId?: string;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

class CopyButton extends React.Component<Props> {
  private handleOpenForCopy = (): void => {
    this.props.onClickTracking?.();
    const showInventory = true;
    const showNotebook = true;

    // For entries we show a clone modal with entry schema options
    if (
      this.props.files.length === 1 &&
      APIUtil.isEntry(this.props.files[0].id) &&
      BenchlingConfig.ELN_ENABLE_SCHEMA_ON_ENTRY_CREATE_MODAL
    ) {
      EntryDAO.get(this.props.files[0].id).then((entry: EntryWithFulfillments) => {
        runModal(CloneModal, {
          modelType: ModelTypeConstants.ENTRY,
          id: entry.id,
          versionId: entry.latestVersionId,
          initialName: `Copy of ${entry.name}`,
        });
      });
    } else {
      FolderSelectorModal.openForCopy(
        {
          initialSelectedFolderId: this.props.initialSelectedFolderId,
          showInventory,
          showNotebook,
        },
        (folderId) => {
          // eslint-disable-next-line no-restricted-syntax
          const selectedIds = _.pluck(this.props.files, 'id');
          FileBrowserActions.copyItems(selectedIds, folderId);
        }
      );
    }
  };

  override render(): JSX.Element {
    return (
      <Tooltip container="body" placement={TooltipPlacement.TOP} title="Copy to...">
        <Button
          aria-label="Copy to folder"
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          disabled={this.props.disabled}
          icon="copy"
          onClick={this.handleOpenForCopy}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    );
  }
}

export default CopyButton;
